import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	purchases: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	purchase: { error: null, loading: false, data: null },
	statuses: { error: null, loading: false, data: null },
};

const { actions, reducer } = createSlice({
	name: 'purchases',
	initialState,
	reducers: {
		getPurchases: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.purchases = {
				...state.purchases,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getPurchasesFailure: (state, { payload }) => {
			state.purchases = {
				...state.purchases,
				error: payload,
				loading: false,
			};
		},
		getPurchasesSuccess: (state, { payload }) => {
			state.purchases = {
				...state.purchases,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getPurchaseById: (state, { payload }) => {
			state.purchase = {
				...state.purchase,
				error: null,
				loading: true,
			};
		},
		getPurchaseByIdFailure: (state, { payload }) => {
			state.purchase = {
				...state.purchase,
				error: payload,
				loading: false,
			};
		},
		getPurchaseByIdSuccess: (state, { payload }) => {
			state.purchase = {
				...state.purchase,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getPurchaseStatuses: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: null,
				loading: true,
			};
		},
		getPurchaseStatusesFailure: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: payload,
				loading: false,
			};
		},
		getPurchaseStatusesSuccess: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getPurchases,
	getPurchasesFailure,
	getPurchasesSuccess,
	getPurchaseById,
	getPurchaseByIdFailure,
	getPurchaseByIdSuccess,
	getPurchaseStatuses,
	getPurchaseStatusesFailure,
	getPurchaseStatusesSuccess,
} = actions;

export { default as purchasesSaga } from './sagas';

export default reducer;
